import axios from "axios";
import { useEffect, useState } from "react";
import Profile from "../../misc/ProfilePicture";
import Cefamoneda from "../../../../../icons/cefamoneda";

//Props
interface Props {
  foto: string;
  puntos: number;
  retos: number;
  name: string;
}

function formatPuntos2(n: number) {
  const v = Math.round((Number(n) || 0) * 100) / 100;
  return v.toLocaleString("es-CR", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}

const UserCard = ({ foto, puntos, retos, name }: Props) => {
  const [image, setImage] = useState("");
  const getImage = async () => {
    if (!foto) return;
    try {
      const { data } = await axios.get(
        `${process.env.REACT_APP_API_URL}/api/s3/signed-url?key=${encodeURIComponent(foto)}`,
        { headers: { "auth-token": sessionStorage.getItem("token") } }
      );
      setImage(data.url);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    getImage();
  }, [foto, name]);

  return (
    <div className="w-full h-full rounded flex items-center justify-center gap-5 px-5 py-3 border border-slate-300">
      <Profile image={image} name={name} />
      <div className="grow">
        <div className="flex items-end justify-end gap-2">
          <div className="text-4xl text-right">
            {formatPuntos2(puntos)}
          </div>
          <Cefamoneda />
        </div>
        <p className="text-s text-right">{retos} Retos Completados</p>
      </div>
    </div>
  );
};

export default UserCard;
